module.exports = {

    data() {
        return {
            autocomplete: null,
            addressParts: {
                street_number: {
                    key: 'short_name',
                    to: 'address',
                    join: ''
                },
                route: {
                    key: 'long_name',
                    to: 'address',
                    join: ' '
                },
                locality: {
                    key: 'long_name',
                    to: 'city',
                    join: ''
                },
                administrative_area_level_1: {
                    key: 'short_name',
                    to: 'state',
                    join: ''
                },
                administrative_area_level_2: {
                    key: 'short_name',
                    to: 'county',
                    join: ''
                },
                postal_code: {
                    key: 'short_name',
                    to: 'zip',
                    join: ''
                },
            }
        }
    },

    mounted() {
        App.bus.$on('google-api-ready', this.createAutocompleteAddress)
    },

    methods: {

        createAutocompleteAddress(id = 'autocomplete-address') {
            this.$nextTick(() => {
                var input = document.getElementById(id);
                if(!input) return;
                this.autocomplete = new google.maps.places.Autocomplete(input ,{});
                this.autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
                this.autocomplete.addListener('place_changed', this.placeChanged);
            })
        },

        placeChanged() {
            var place = this.autocomplete.getPlace();
            this.setAddressFromPlace(place)
            if (!place.geometry) {
                Toast.error("No details available for input: '" + place.name + "'");
                return;
            }
        },

        setAddressFromPlace(place) {
            for (var key in this.addressParts) {
                this.form[this.addressParts[key].to] = '';
            }
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (this.addressParts[addressType]) {
                    var val = (this.addressParts[addressType].join + place.address_components[i][this.addressParts[addressType].key]);
                    this.form[this.addressParts[addressType].to] += val;
                }
            }
        },
    }
}
